import React, { useState } from "react";


import { AppointmentsPage } from "./containers/appointmentsPage/AppointmentsPage";
import { ContactsPage } from "./containers/contactsPage/ContactsPage";
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Router,
} from "react-router-dom";
import Login from './pages/Login'
import Signup from './pages/Signup';
import Home from './pages/Home';
import Refreshmentpage from './pages/Refreshmentpage';
import TodoList from './pages/TodoList';

import FindCouncellor from './pages/Counsellor/FindCounsellor';

import ResponsiveAppBar from "./components/Navbar";
import Album from "./pages/meditate";


import FindActivities from "./pages/Interests/FindActivities";

function App() {
  return (
    <div className="App bg-gradient-to-r from-cyan-500 to-blue-500">
  <ResponsiveAppBar/>
    <BrowserRouter>
    
    <Routes>
    <Route path='/login' element={<Login/>}/>    
    <Route path='/signup' element={<Signup/>}/>
    <Route path='/' element={<Refreshmentpage/>}></Route>
    <Route path='/login' element={<Home/>}/>
    <Route path='/task-schedular' element={<TodoList/>}/>
    <Route path='/meditate' element={<Album/>}/>

    <Route path='/find_counsellor' element={<FindCouncellor/>}></Route>
    <Route path='/interest' element={<FindActivities/>}></Route>
    </Routes>
  
  </BrowserRouter>
    </div>
  );
}
export default App;
